import { useLazyQuery } from "@apollo/client";

import { GET_FILTERS } from "../../../GraphQL/getFilters";
import { ESupportedGames } from "../../../@types";

const filterTypesByGame: Record<ESupportedGames, string> = {
  [ESupportedGames.CS2]: "CS2",
  [ESupportedGames.CSGO]: "CS_GO",
  [ESupportedGames.DOTA2]: "DOTA2",
  [ESupportedGames.FORTNITE]: "FORTNITE",
  [ESupportedGames.LOL]: "LOL",
  [ESupportedGames.OW2]: "OW2",
  [ESupportedGames.ALL]: "",
  [ESupportedGames.NONE]: "",
};

export const useFilters = (game: ESupportedGames) => {
  const [
    fetchFilters,
    { data: filterData, loading: filterLoading, error: filterError },
  ] = useLazyQuery(GET_FILTERS, {
    fetchPolicy: "cache-first",
  });

  const formattedGame =
    game === ESupportedGames.ALL ? null : filterTypesByGame[game] || "";

  return {
    fetchFilters,
    filterData,
    filterLoading,
    filterError,
    formattedGame,
  };
};

